import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import GLOBAL, { slideDown ,slideUp} from '../../components/GLOBAL'
import "tom-select/dist/css/tom-select.default.css";
import TomSelect from "tom-select";
import JustValidate from 'just-validate';
import AOS from 'aos';
import 'aos/dist/aos.css';
import IMask from 'imask';
import axios from 'axios';

AOS.init();

function wrapChars(str) {
	let result = "";
	let d = 0;
	for (let i = 0; i < str.length; i++) {
		let s = str[i];
		if (str[i] == ' ') {
			s = "&nbsp;"
		}
		result += '<span class="char" style="--d: ' + d + 's">' + s + '</span>';
		d += 0.02;
	}
	return result;
}

export function initHoverLinks() {
	return;
	document.querySelectorAll('body:not(.is-admin) .js-link, body:not(.is-admin) .js-links a:not(._not-animate), body:not(.is-admin) .js-links button:not(._not-animate)').forEach((link) => {
		link.classList.add('hover-link');
		link.innerHTML = `<span class="hover-link__content"><span class="hover-link__text">${link.innerHTML}</span><span class="hover-link__text2">${link.innerHTML}</span><span>`
		link.querySelectorAll('.hover-link__text,.hover-link__text2').forEach((text) => {
			if (text.querySelector('span')) {
				text = text.querySelector('span');
			}
			if (text.querySelector('svg')) {
				text.innerHTML = `<span class="char" style="--d: 0s">${text.innerHTML}</span>`;
			} else {
				text.innerHTML = wrapChars(text.innerText)
			}

		})
	})
}

document.querySelectorAll('._mask-phone').forEach((input) => {
	IMask(input,  {
		mask: '+{7}(000)000-00-00'
	});
})
document.querySelectorAll('._mask-date').forEach((input) => {
	IMask(input,  {
		mask: Date,
	});
})
document.querySelectorAll('._mask-time').forEach((input) => {
	IMask(input,  {
		mask: '00:00'
	});
})

document.querySelectorAll('.form-1__form').forEach((form) => {
	const validator = new JustValidate(form);

	form.querySelectorAll('._required').forEach((input) => {
		validator.addField(input, [
			{
				rule: 'required',
			},
		])
	})
	form.querySelectorAll('._required-mail').forEach((input) => {
		validator.addField(input, [
			{
				rule: 'required',
			},
			{
				rule: 'email',
			},
		])
	})
	validator.onSuccess((event) => {
		if (window.submitInProgress) return;
		window.submitInprogress = true;
		form.classList.remove('_success', '_error');

		console.log({method:form.getAttribute('method'),url:form.getAttribute('action')});

		axios({
            method: form.getAttribute('method'),
            url: form.getAttribute('action'),
            data: form
        })
		.then((response) => {
			window.submitInProgress = false;
			renderResult(response.data);
			console.log(response.data.status);

			// Успех
			if (response.data.status === 'success') {
				form.classList.add('_success')
				sendFormMetrika(form);
				renderResult({
					content: `<span class="">Форма отправлена успешно!!!<br/><br/>${response.data.message}</span>`
				});
				form.reset();
			} else {
				form.classList.add('_error');
				console.log(`Ошибка загрузки данных\n${response.data.message}`);

				renderResult({
					content: `<span class="_c-red">Произошла ошибка.<br/><br/>${response.data.message}</span>`
				});
			}
		})
		.catch((error) => {
			window.submitInProgress = false;
			console.log('Ошибка загрузки данных');
			console.log(error);
			form.classList.add('_error');

			renderResult({
				content: `<span class="_c-red">Произошла ошибка. Попробуйте позже.</span>`
			});
		});

		function renderResult(data) {
			const r = form.querySelector('.js-result p');
			if (data.content && r) {
				r.innerHTML = data.content;
			}
		}

		form.querySelectorAll('.js-form-ok').forEach(btn => {
			btn.addEventListener('click', () => {
				form.classList.remove('_success', '_error');
			});
		});
	});
})


document
	.querySelectorAll(".accordion-grid")
	.forEach(function (wrap) {
		wrap
			.querySelectorAll(".accordion__head")
			.forEach(function (btn) {
				btn.addEventListener('click',()=>{
					const item = btn.closest('.accordion');
					if(item.classList.contains('_open')){
						wrap.querySelectorAll('.accordion._open').forEach((i)=>{
							i.classList.remove('_open')
							// slideUp(i.querySelector('.accordion__body'))
						})
					}else{
						wrap.querySelectorAll('.accordion._open').forEach((i)=>{
							i.classList.remove('_open')
							// slideUp(i.querySelector('.accordion__body'))
						})
						item.classList.add('_open')
						// slideDown(item.querySelector('.accordion__body'))
					}
				})
			});
	});
document.querySelectorAll(".js-select")
	.forEach(function (item) {
		new TomSelect(item, { maxItems:1});
	});

document
	.querySelectorAll("body:not(.is-admin) .img-slider")
	.forEach(function (item) {
		let slider = new Swiper((item), {
			slidesPerView: 1,
			spaceBetween: 10,
			breakpoints: {
				599: {
					slidesPerView: 2,
					spaceBetween: 11,
				},
				1600: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
			}, navigation: {
				nextEl: item.querySelector(".swiper-next"),
				prevEl: item.querySelector(".swiper-prev"),
			},
		});
	});
document
	.querySelectorAll("body:not(.is-admin) .afisha-block")
	.forEach(function (item) {
		let slider = new Swiper((item.querySelector('.afisha-block__swiper')), {
			slidesPerView: 'auto',
			spaceBetween: 10,
			pagination: {
				el: item.querySelector('.afisha-block__bullets'),
				clickable: true,
			},
			breakpoints: {
				599: {
					slidesPerView: 2,
					spaceBetween: 11,
				},
				1600: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
			}, navigation: {
				nextEl: item.querySelector(".swiper-next"),
				prevEl: item.querySelector(".swiper-prev"),
			},
		});
	});



document
	.querySelectorAll("body:not(.is-admin) .swiper-3-img")
	.forEach(function (item) {
		let slider = new Swiper((item), {
			slidesPerView: 'auto',
			spaceBetween: 8,
			breakpoints: {
				500: {
					slidesPerView: 2,
					spaceBetween: 12,
				},
				1099: {
					slidesPerView: 3,
					spaceBetween: 10,
				},
				1600: {
					slidesPerView: 3,
					spaceBetween: 16,
				},
			}, navigation: {
				nextEl: item.querySelector(".swiper-next"),
				prevEl: item.querySelector(".swiper-prev"),
			},pagination: {
				el: item.querySelector(".swiper-3-img__pagi"),
				type: 'custom',
				renderCustom: function (swiper, current, total) {
					return current.toString().padStart(2, "0") + '/' + ((total ).toString().padStart(2, "0") );
				}
			},
		});
	});

document
	.querySelectorAll("body:not(.is-admin) .four-cards__swiper")
	.forEach(function (item) {
		let slider = new Swiper((item), {
			slidesPerView: 'auto',
			spaceBetween: 10,
			breakpoints: {

				1099: {
					slidesPerView: 4,
					spaceBetween: 10,
				},
				1600: {
					slidesPerView: 4,
					spaceBetween: 16,
				},
			}, navigation: {
				nextEl: item.querySelector(".swiper-next"),
				prevEl: item.querySelector(".swiper-prev"),
			},pagination: {
				el: item.querySelector(".swiper-3-img__pagi"),
				type: 'custom',
				renderCustom: function (swiper, current, total) {
					return current.toString().padStart(2, "0") + '/' + ((total ).toString().padStart(2, "0") );
				}
			},
		});
	});


	document
	.querySelectorAll("body:not(.is-admin) .tarif-slider")
	.forEach(function (item) {
		let slider = new Swiper((item), {
			slidesPerView: 'auto',
			spaceBetween: 10,
			breakpoints: {

				1099: {
					slidesPerView: 3,
					spaceBetween: 11,
				},
				1600: {
					slidesPerView: 3,
					spaceBetween: 16,
				},
			}, navigation: {
				nextEl: item.querySelector(".swiper-next"),
				prevEl: item.querySelector(".swiper-prev"),
			},
		});
	});

	document.querySelectorAll("body:not(.is-admin) .text:has(hr)")
	.forEach(function (item) {
		const more = document.createElement("button");
		more.classList.add('text__more')
		more.classList.add('js-link')
		more.innerHTML = `<span>читать всё</span><svg class="icon icon-plus"><use xlink:href="sprite.svg#plus"></use></svg>`
		item.append(more);
		item.classList.add('_hide')
		more.addEventListener('click',()=>{
			item.classList.remove('_hide')
		})
	})
	document.querySelectorAll("body:not(.is-admin) .gallery")
	.forEach(function (item) {
		let slider = item.querySelector('.gallery__swiper');
		if (slider)
			new Swiper((slider), {
				slidesPerView: 1,
				spaceBetween: 8,
				loop:true,
				breakpoints: {
					599: {
						slidesPerView: 2,
						spaceBetween: 8,
					},
					1099: {
						slidesPerView: 3,
						spaceBetween: 11,
					},
					1600: {
						slidesPerView: 3,
						spaceBetween: 16,
					},
				}, navigation: {
					nextEl: item.querySelector(".swiper-next"),
					prevEl: item.querySelector(".swiper-prev"),
				},
			});
	});
	document.querySelectorAll("body:not(.is-admin) .gallery2")
	.forEach(function (item) {
		let slider = item.querySelector('.gallery2__slider');
		console.log(item,slider)
		if (slider)
			new Swiper((slider), {
				slidesPerView: "auto",
				spaceBetween: 8,
				centeredSlides:true,
				loop:true,
				breakpoints: {
					599: {
						spaceBetween: 8,
					},
					1099: {
						spaceBetween: 11,
					},
					1600: {
						spaceBetween: 16,
					},
				}, navigation: {
					nextEl: item.querySelector(".swiper-next"),
					prevEl: item.querySelector(".swiper-prev"),
				},
					pagination: {
				el: item.querySelector(".gallery2__slider-pagi"),
				type: 'custom',
				renderCustom: function (swiper, current, total) {
					return current.toString().padStart(2, "0") + '/' + ((total ).toString().padStart(2, "0") );
				}
			},
			});
	});




document
	.querySelectorAll(".afisha-block")
	.forEach(function (item) {
		const days = item.querySelectorAll('.afisha-block__day');
		const daysWrap = item.querySelectorAll('.afisha-block__days');
		const dates = item.querySelectorAll('.afisha-block__date');
		const cards = item.querySelectorAll('.afisha-block__card');
		const months = item.querySelectorAll('.afisha-block__month');
		const slider = item.querySelector('.afisha-block__swiper').swiper;

		months.forEach((month)=>{
			month.addEventListener('click',()=>{
				months.forEach((it)=>{
					it.classList.remove('_active')
				})
				daysWrap.forEach((wrap)=>{
					if(month.dataset.month==wrap.dataset.month){
						wrap.classList.remove('_hidden');
						wrap.querySelector('.afisha-block__day').click()
					}else{
						wrap.classList.add('_hidden')
					}
				})
				month.classList.add('_active')
			})
		})
		days.forEach((date)=>{
			date.addEventListener('click',()=>{
				days.forEach((it)=>{
					it.classList.remove('_active')
				})
				cards.forEach((card)=>{
					if(date.dataset.filter==card.dataset.filter){
						card.classList.remove('_hidden')
					}else{
						card.classList.add('_hidden')
					}
				})
				date.classList.add('_active')

				slider.updateProgress();
				slider.updateSize();
				slider.updateSlides();
				slider.update();
			})
		})
		dates.forEach((date)=>{
			date.addEventListener('click',()=>{
				dates.forEach((it)=>{
					it.classList.remove('_active')
				})
				cards.forEach((card)=>{
					if(date.dataset.filter==card.dataset.filter){
						card.classList.remove('_hidden')
					}else{
						card.classList.add('_hidden')
					}
				})
				date.classList.add('_active')
			})
		})

		dates[0].click();
		months[0].click();
	})

document
	.querySelectorAll(".more")
	.forEach(function (parent) {
		let itemsPerLoad = parent.dataset.count;
		if (!itemsPerLoad) {
			itemsPerLoad = 99
		}
		   	const filters = parent.querySelectorAll('.more__filter');
            const items = parent.querySelectorAll('.more__item');
            const loadMoreBtn = parent.querySelector('.more__btn');

            let currentFilter = 'all';
            let visibleCount = 0;

            filterItems(parent.querySelector('.more__filter._active')?parent.querySelector('.more__filter._active').dataset.filter:"all");

            filters.forEach(filter => {
                filter.addEventListener('click', function() {
                    const filterValue = this.dataset.filter;
                    currentFilter = filterValue;
                    filters.forEach(f => f.classList.remove('_active'));
                    this.classList.add('_active');
                    filterItems(filterValue);
                });
            });

            loadMoreBtn?.addEventListener('click', function() {
                showMoreItems();
            });

            function filterItems(filter) {
                visibleCount = 0;

                items.forEach(item => {
                    const category = item.dataset.filter;
                    item.classList.remove('visible');
                    if (filter === 'all' || category.split(',').indexOf(filter) != -1) {
						if( loadMoreBtn){
							 if (visibleCount < itemsPerLoad) {
								item.classList.remove('_hidden');
								visibleCount++;
							}else{
								item.classList.add('_hidden');
							}
						}else{
							item.classList.remove('_hidden');
						}

                    }else{
						item.classList.add('_hidden');
					}
                });
                if(loadMoreBtn) updateLoadMoreButton();

				AOS.refresh();
            }

            function showMoreItems() {
                let itemsToShow = itemsPerLoad;

                items.forEach(item => {
                    const category = item.dataset.filter;

                    if (currentFilter === 'all' || category.split(',').indexOf(currentFilter) != -1) {
                        if (item.classList.contains('_hidden') && itemsToShow > 0) {
                            item.classList.remove('_hidden');
                            visibleCount++;
                            itemsToShow--;
                        }
                    }
                });

                if(loadMoreBtn) updateLoadMoreButton();
            }

            function updateLoadMoreButton() {
                const totalVisibleItems = Array.from(items).filter(item => {
                    const category = item.dataset.filter;
                    return (currentFilter === 'all' || category.split(',').indexOf(currentFilter) != -1);
                }).length;

                if (visibleCount < totalVisibleItems) {
                    loadMoreBtn.style.display = 'block';
                } else {
                    loadMoreBtn.style.display = 'none';
                }
            }

	});

document
	.querySelectorAll("body:not(.is-admin) .bilet-slider")
	.forEach(function (item) {
		let slider = new Swiper((item), {
			slidesPerView: "auto",
			spaceBetween: 10,
			breakpoints: {
				1099: {
					slidesPerView: 3,
					spaceBetween: 11,
				},
				1600: {
					slidesPerView: 3,
					spaceBetween: 16,
				},
			}, navigation: {
				nextEl: item.querySelector(".swiper-next"),
				prevEl: item.querySelector(".swiper-prev"),
			},
		});
	});
